import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/pay-fixed-allowances',
    name: 'pay-fixed-allowance',
    meta: { middleware: authenticate },
    component: () => import('@/pages/hr/pay-fixed-allowance')
  }
]
